import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auths: [],
  auth: {
    email: "",
    password: "",
    newPassword: "",
    name: "",
    lastName: "",
    identification: "",
    cellPhone: "",
    country: "",
    city: "",
    address: "",
    company: "",
    charge: {
      id: 0,
      name: "",

    },
    department: {
      id: 0,
      name: "",

    },
    company: {
      id: 0,
      name: "",  

    },
    status: false,
    token: "",
    fullName: "",
    ordens: [],
    loginVisible: false,
  },
  captchaVerify: false,
  token: "",
 
  authValidation: {
    isValid: true,
    isUserInfoValid: false,
    isUserGeneralInfoValid: false,
    email: {
      isValid: true,
      errorMessage: "El formato del correo es incorrecto.",
    },
    name: {
      isValid: true,
      errorMessage: "El campo name no debe estar vacio",
    },
    lastName: {
      isValid: true,
      errorMessage: "El campo lastName no debe estar vacio",
    },
    identification: {
      isValid: true,
      errorMessage: "El campo Documento de Identidad no debe estar vacio",
    },
    cellPhone: {
      isValid: true,
      errorMessage: "El campo celular no debe estar vacio",
    },
    country: {
      isValid: true,
      errorMessage: "Debe seleccionar un país",
    },
    city: {
      isValid: true,
      errorMessage: "Debe seleccionar una ciudad",
    },
    address: {
      isValid: true,
      errorMessage: "Debe seleccionar una ciudad",
    },
    company: {
      isValid: true,
      errorMessage: "Debe seleccionar una ciudad",
    },
    password: {
      isValid: true,
      errorMessage: "Contraseña incorrecta",
    },
    newPassword: {
      isValid: true,
      errorMessage: "Contraseña incorrecta",
    },
    repassword: {
      isValid: true,
      errorMessage: "Contraseña incorrecta",
    },
    
  },
};

const userSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    restartState(state) {
      state.auth = {};
      state.auths = [];
    },
    setauths(state, actions) {
      state.auths = actions.payload.auths;
      state.auth =
        actions.payload.auth !== undefined ? actions.payload.auth : {};
    },
    setauth(state, actions) {
      state.auth = actions.payload.auth;
      state.auths =
        actions.payload.auths !== undefined ? actions.payload.auths : [];
    },
    settoken(state, actions) {
      state.token = actions.payload.token;
    },
    setLoginVisible(state, actions) { 
      state.auth.loginVisible = actions.payload;
    },
    setcaptchaVerify(state, actions) {
      state.captchaVerify = actions.payload.captchaVerify;
    },
    setIsConference(state, actions) {
      state.isConference = actions.payload;
    },
    setIsRegister(state, actions) {
      state.isRegister = actions.payload;
    },
    modifyPropertyValue(state, actions) {
      state.auth[actions.payload.id] = actions.payload.value;
    },
    setIsValid(state, actions) {
      state.authValidation = {
        identification: {
          ...state.authValidation.identification,
          isValid:
            actions.payload.identification !== ""
        },
        email: {
          ...state.authValidation.email,
          isValid:
            actions.payload.email !== "" && actions.payload.email.includes("@"),
        },
        name: {
          ...state.authValidation.name,
          isValid: actions.payload.name !== "",
        },
        lastName: {
          ...state.authValidation.lastName,
          isValid: actions.payload.lastName !== "",
        },
        cellPhone: {
          ...state.authValidation.cellPhone,
          isValid:
            actions.payload.cellPhone !== "" &&
            actions.payload.cellPhone.length >= 10,
        },
        country: {
          ...state.authValidation.country,
          isValid: actions.payload.country !== "",
        },
        password: {
          ...state.authValidation.password,
          isValid:
            actions.payload.password !== "" ||
            actions.payload.password !== actions.payload.repassword,
        },
        repassword: {
          ...state.authValidation.repassword,
          isValid:
            actions.payload.repassword !== "" ||
            actions.payload.repassword !== actions.payload.password,
        },
      };
      state.authValidation.isValid =
        state.authValidation.email.isValid &&
        state.authValidation.name.isValid &&
        state.authValidation.lastName.isValid &&
        state.authValidation.cellPhone.isValid &&
        state.authValidation.country.isValid &&
        state.authValidation.identification.isValid;

      state.authValidation.isUserInfoValid =
        state.authValidation.email.isValid &&
        state.authValidation.password.isValid &&
        state.authValidation.repassword.isValid;
    },
    setUserGeneralInfoValid(state, actions) {
      state.authValidation = {
        email: {
          ...state.authValidation.email,
          isValid: true,
        },
        name: {
          ...state.authValidation.name,
          isValid: actions.payload.name !== "",
        },
        lastName: {
          ...state.authValidation.lastName,
          isValid: actions.payload.lastName !== "",
        },
        cellPhone: {
          ...state.authValidation.cellPhone,
          isValid:
            actions.payload.cellPhone !== "" &&
            actions.payload.cellPhone.length >= 10,
        },
        identification: {
          ...state.authValidation.identification,
          isValid: actions.payload.identification !== "",
        },
        country: {
          ...state.authValidation.country,
          isValid: true,
        },

        password: {
          ...state.authValidation.password,
          isValid: true,
        },
        repassword: {
          ...state.authValidation.repassword,
          isValid: true,
        },
      };

      state.authValidation.isUserGeneralInfoValid =
        state.authValidation.name.isValid &&
        state.authValidation.lastName.isValid &&
        state.authValidation.identification.isValid &&
        state.authValidation.cellPhone.isValid;
    },
    setUserInfoValid(state, actions) {
      state.authValidation = {
        email: {
          ...state.authValidation.email,
          isValid: true,
        },
        name: {
          ...state.authValidation.name,
          isValid: true,
        },
        lastName: {
          ...state.authValidation.lastName,
          isValid: true,
        },
        cellPhone: {
          ...state.authValidation.cellPhone,
          isValid: true,
        },
        country: {
          ...state.authValidation.country,
          isValid: true,
        },
        identification: {
          ...state.authValidation.identification,
          isValid: true,
        },
        password: {
          ...state.authValidation.password,
          isValid:
            actions.payload.password !== "" ||
            actions.payload.password !== actions.payload.repassword,
        },
        repassword: {
          ...state.authValidation.repassword,
          isValid:
            actions.payload.repassword !== "" ||
            actions.payload.repassword !== actions.payload.password,
        },
      };

      state.authValidation.isUserInfoValid =
        state.authValidation.email.isValid &&
        state.authValidation.password.isValid &&
        state.authValidation.repassword.isValid;
    },

    setFieldValid(state, actions) {
      state.authValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice;
